import React from 'react'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { QuotesListTable } from 'modules/finance/components/Quotes/QuotesListTable'
import { SalesRootPageOutletContext } from 'modules/finance/pages/SalesRootPage'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const QuotesListPage = () => {
  const { dealId } = useParams()
  const { routesVisibility: salesRootVisibility } = useOutletContext<SalesRootPageOutletContext>()
  const authorized = salesRootVisibility.finance._policies.sidebarSeeFinanceQuotesSubLevelItem.can

  const { company, access } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  useEffect(() => {
    if (Number(dealId)) {
      track(trackingEvents.accounting.deals.viewDealQuotes)
    } else {
      track(trackingEvents.accounting.quotes.viewQuotesPage)
    }
  }, [])

  const handleClickAdd = () => {
    navigate(navigation.finance.sales.quotes.new.fullPath(), {
      state: { dealId: Number(dealId) },
    })
  }

  return (
    <ResponsivePage.Body authorized={authorized} variant="full">
      <QuotesListTable
        companyId={company.id}
        locale={access.locale}
        dealId={dealId ? Number(dealId) : undefined}
        onClickAdd={handleClickAdd}
        showCustomerColumn
      />
    </ResponsivePage.Body>
  )
}

export default QuotesListPage
